import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import "./RSVPSection.css";
import { ConfirmationModal } from "./components/modal-confirmation/ConfirmationModal";
import { QRCodeModal } from "./components/qr-code-modal/QRCodeModal";
import { TapHandIcon } from "../../icons/SvgIcons";
import { useGuest } from "../../../contexts/GuestContext";

export const RSVPSection = ({ showQRModal = false }) => {
  const { guest } = useGuest();
  return (
    <Dialog.Root>
      <section className="confirm-section">
        <div className="confirm-title-wrapper">
          <div className="confirm-title-stack">
            <p className="confirm-title-main">Confirma tu</p>
            <span className="confirm-title-fancy">ASISTENCIA</span>
          </div>
        </div>

        <p className="confirm-subtitle">
          Agradecemos tu confirmación de asistencia antes del
        </p>
        <div className="date-container">
          <span className="confirm-date">10</span> DE SEPTIEMBRE{" "}
          <span className="confirm-date">2025</span>
        </div>
        {/* <p className="confirm-date">10 DE SEPTIEMBRE DEL 2025</p> */}

        <p className="confirm-note">
          Respetuosamente
          <br />
          NO NIÑOS
        </p>

        <div className="date-container">
          {guest?.invited ? (
            <p className="confirm-date">
              PASES ASIGNADOS{" "}
              <span className="confirm-date" style={{ fontWeight: "bold" }}>
                {guest?.invited}
              </span>
            </p>
          ) : null}
        </div>
        <p className="confirm-note">
          Los lugares son personales e intransferibles
        </p>

        <Dialog.Trigger asChild>
          <button
            className={`confirm-button ${
              showQRModal ? "confirm-button-auto" : ""
            }`}
            style={
              showQRModal
                ? { backgroundColor: "#8c906c", color: "white", width: 150 }
                : {}
            }
          >
            <span className="confirm-button-content">
              {showQRModal ? "CLICK" : "CONFIRMAR AQUÍ"}
              <TapHandIcon
                className="confirm-button-icon-absolute"
                fill="white"
              />
            </span>
          </button>
        </Dialog.Trigger>

        <p className="confirm-message">
          Nada nos haría más felices que celebrar este día tan especial rodeado
          de quienes más queremos.
        </p>
        <div className="footer-wrapper">
          <div className="footer-stack">
            <p className="footer-left">¡LOS ESPERAMOS</p>
            <p className="footer-right">CON MUCHO CARIÑO!</p>
          </div>
        </div>
      </section>
      {showQRModal ? <QRCodeModal /> : <ConfirmationModal />}
    </Dialog.Root>
  );
};
